import React, { Component } from 'react';
import { connect } from 'react-redux';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { post } from '@/util/helpers/ajax-helpers';
import { closeReactModal, loadViewsData } from '../../actions';
import { VIEW_SAVED } from '../../actions/constants';
import ModalContent from '../ModalContent';
import { MAX_TEXTFIELD_LENGTH } from '../../reducers/modal_save_layers';
import { standardErrorHandler } from '../../actions/helpers';
import { QUERY_NAME_INPUT } from '../../constants/test-ids';

class ModalDuplicateView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      saving: false,
    };
    this.onSaveButtonClicked = this.onSaveButtonClicked.bind(this);
  }

  title() {
    return <span>Duplicate query</span>;
  }

  componentDidMount() {
    this.takeFocus();
  }

  takeFocus() {
    setTimeout(() => {
      if (this._input) {
        this._input.select();
      }
    }, 500);
  }

  onTextFieldChange(event) {
    this.setState({
      name: event.target.value.substring(0, MAX_TEXTFIELD_LENGTH),
    });
  }

  onSaveButtonClicked() {
    const { modalClosed, saveSuccessful, original, saveError } = this.props;

    this.setState({
      saving: true,
    });
    const data = {
      existing: original.id(),
      name: this.state.name,
    };
    post('duplicating query', `/views/${data.existing}/duplicate`, {
      _name: data.name.trim(),
    })
      .then(() => {
        NotificationManager.success(
          `New query \"${data.name.trim()}\" saved`,
          null,
          5000,
        );
        modalClosed();
        saveSuccessful();
      })
      .catch(() => {
        this.setState({
          saving: false,
        });
        saveError();
      });
  }

  render() {
    const { modalClosed } = this.props;

    return (
      <ModalContent
        onClose={modalClosed}
        extraSmall
        header={this.title()}
        footer
        disabled={this.state.name.length === 0}
        onSubmit={this.onSaveButtonClicked}
      >
        <div>
          <input
            id={QUERY_NAME_INPUT}
            key="insight-name"
            placeholder="Give your query a name"
            className="form-control set-input-height"
            style={{ height: '45px' }}
            onChange={(event) => this.onTextFieldChange(event)}
            value={this.state.name}
            ref={(input) => (this._input = input)}
          />
        </div>
      </ModalContent>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    modalClosed: () => {
      dispatch(closeReactModal());
    },
    saveSuccessful: () => {
      dispatch(loadViewsData()); // reload views data (needed, in particular, to update datasource.totalSavedViews)
    },
    saveError: () => {
      standardErrorHandler(VIEW_SAVED, dispatch);
    },
  };
};

export default connect(null, mapDispatchToProps)(ModalDuplicateView);
